import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import AudioComponent from '../../tools/vueNodeView/AudioComponent.vue'

export const Audio = Node.create({
  name: 'audio',
  atom: true,
  draggable: true,
  isolating: true,

  addOptions() {
    return {
      HTMLAttributes: {},
      inline: false,
    }
  },
  inline() {
    return this.options.inline
  },
  group() {
    return this.options.inline ? 'inline' : 'block'
  },
  addAttributes() {
    return {
      url: {
        default: null,
        parseHTML: element => ({ url: element.getAttribute('url') }),
        renderHTML: attributes => ({
          url: attributes.url,
        }),
      },
    }
  },
  parseHTML() {
    return [
      {
        tag: 'vue-component',
      },
    ]
  },
  renderHTML({ HTMLAttributes }) {
    return ['vue-component', mergeAttributes(HTMLAttributes)]
  },
  addNodeView() {
    return VueNodeViewRenderer(AudioComponent)
  },
  addCommands() {
    return {
      setAudio:
        options =>
        ({ commands }) =>
          commands.insertContent({
            type: this.name,
            attrs: options,
          }),
    }
  },
})
